export enum DRAWER_APPEARANCE {
  FOUNDATION = 'foundation',
}
export enum DRAWER_DISMISSAL {
  STANDARD = 'standard',
  BLOCKED = 'blocked',
}
